import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "section-steps",
  style: {"padding-bottom":"10px"}
}
const _hoisted_2 = {
  class: "o-grid o-grid--align-center",
  "aria-label": "Schritte",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "u-remove-list-styles" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.items)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                (item.label)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      tabindex: "-1",
                      class: _normalizeClass(_ctx.styleClass(index)),
                      onClick: ($event: any) => (_ctx.gotoPage(item, index))
                    }, [
                      _createElementVNode("span", {
                        class: "u-round-number",
                        innerHTML: index + 1
                      }, null, 8, _hoisted_5),
                      _createElementVNode("span", {
                        class: "link-text",
                        innerHTML: item.label
                      }, null, 8, _hoisted_6)
                    ], 10, _hoisted_4))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}